@if (isLoaded) {
<form

  [formGroup]="paymentTermForm"
  id="payment-term-form-container"
  novalidate>
  <se-fe-grid seFeGridOpts="loose">
    <se-fe-grid-cell
      seFeGridOpts="1/1@mobile"
      class="top-element">
      <se-fe-header
        [seFeDataTitle]="'MULTI_PAYMENT_TERMS_SELECTOR.title' | translate"
        seFeDataSize="small"></se-fe-header>
      <app-payment-terms-preview
        [isInvoice]="isInvoice"
        [preSelectedTerm]="preSelectedTerm"
        [paymentTermForm]="paymentTermForm"
        [applied]="applied"
        [fullAmountUpfront]="fullAmountUpfront()"></app-payment-terms-preview>

      @if (!fullAmountUpfront()) {
<div>
        <se-fe-menu
          #multiPaymentTermsMenu
          id="multi-payment-terms-menu"
          [seFeDataOptions]="dataOptions">
          <!-- seFeMenuToolbar content projection start -->
          <se-fe-toolbar
            seFeMenuToolbar
            data-testid="payment-term-search"
            seFeDataAriaLabel="search"
            (seFeQueryChange)="searchTerms($event)">
            @if (addPaymentTerms) {
<se-fe-icon

              (click)="openModal()"
              data-testid="add-payment-term"
              seFeDataName="plus_circle_outline"
              seFeDataSize="600"
              seFeDataColor="gray-900"></se-fe-icon>
}
          </se-fe-toolbar>

          <!-- seFeMenuToolbar content projection end -->
        </se-fe-menu>

        @if (!(selectedValues.length === 4)) {
<se-fe-button

          [seFeDataEmphasis]="'medium'"
          data-testid="show-payment-terms"
          [seFeMenuTrigger]="multiPaymentTermsMenu">
          {{ 'MULTI_PAYMENT_TERMS_SELECTOR.payment_term_placeholder' | translate }}
        </se-fe-button>
}

        <se-fe-header
          [seFeDataTitle]="'MULTI_PAYMENT_TERMS_SELECTOR.TITLES.allowed_terms' | translate"
          seFeDataSize="xsmall"></se-fe-header>
      </div>
}

      <div [hidden]="selectedValues.length <= 1">
        @if (isInvoice && !saleGroupItems) {
<se-fe-grid

          seFeGridOpts="snug">
          <se-fe-grid-cell
            seFeGridOpts="1/1@mobile"
            class="upfront-form">
            <se-fe-checkbox
              seFeDataId="initialAmount"
              formControlName="showPartialAmountInput"
              (change)="toggleUpfrontPayment()">
              <ng-template seFeFormFieldLabel>
                {{ 'MULTI_PAYMENT_TERMS_SELECTOR.PLAN_PREVIEW.UPFRONT_PAYMENT.label' | translate }}
              </ng-template>
            </se-fe-checkbox>
          </se-fe-grid-cell>
          @if (partialAmountInput) {
<se-fe-grid-cell

            seFeGridOpts="1/1@mobile"
            class="partial-amount">
            <se-fe-form-field [seFeDataConfig]="upfrontAmountFieldConfig">
              <se-fe-form-field-text
                seFeDataAutoComplete="off"
                (blur)="setStatusAndFormatAmount()"
                (focus)="setUpfrontAmountFocus()"
                formControlName="upfrontAmount"
                seFeDataPlaceholder="0.00">
                <se-fe-icon
                  seFeFormFieldTextBefore
                  seFeDataName="dollar"
                  seFeDataSize="500"></se-fe-icon>
              </se-fe-form-field-text>
            </se-fe-form-field>
            <se-fe-button
              [seFeDataEmphasis]="'medium'"
              (click)="applyUpfrontAmount($event)">
              {{ 'MULTI_PAYMENT_TERMS_SELECTOR.UPFRONT_PAYMENT.apply_button_text' | translate }}
            </se-fe-button>
          </se-fe-grid-cell>
}
          @if (partialAmountInput && f.upfrontAmount?.valid && !applied) {
<se-fe-alert

            seFeDataType="error">
            {{ 'MULTI_PAYMENT_TERMS_SELECTOR.UPFRONT_PAYMENT.ERRORS.apply' | translate }}
          </se-fe-alert>
}
        </se-fe-grid>
}
      </div>
    </se-fe-grid-cell>
  </se-fe-grid>
</form>
}

@if (!isLoaded) {
<se-fe-block>
  <div class="centered">
    <se-fe-spinner
      [seFeDataSize]="900"
      [seFeDataCenter]="center"></se-fe-spinner>
  </div>
</se-fe-block>
}
